    document.addEventListener("DOMContentLoaded", function() {
        // Initialize PDP slider with improved navigation.
        // Defer creation until near the viewport to avoid a forced-reflow on load.
        var lazyInit = window.lazySwiper || function(el, fn) { fn(el); };
        var pdpEl = document.querySelector('.custom-swiper-container');
        if (!pdpEl) return;
        lazyInit(pdpEl, function(el) {
        const pdpSwiper = new Swiper(el, {
          slidesPerView: 2,
          slidesPerGroup: 1, // Changed from 2 to 1 for smoother navigation
          spaceBetween: 15,
          loop: false,
          watchOverflow: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
            dynamicBullets: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 4,
              slidesPerGroup: 1 // Changed from 4 to 1
            },
            768: {
              slidesPerView: 3,
              slidesPerGroup: 1 // Changed from 2 to 1
            },
            370: {
              slidesPerView: 2,
              slidesPerGroup: 1 // Changed from 2 to 1
            }
          },
          on: {
            init: function() {
              updatePDPNavigation(this);
            },
            slideChange: function() {
              updatePDPNavigation(this);
            }
          }
        });
        });

        // Custom function to handle PDP slider navigation
        function updatePDPNavigation(swiper) {
          const nextBtn = document.querySelector('.custom-swiper-container .swiper-button-next');
          const prevBtn = document.querySelector('.custom-swiper-container .swiper-button-prev');
          
          if (!nextBtn || !prevBtn) return;
          
          // Always enable buttons (we'll handle visibility ourselves)
          nextBtn.classList.remove('swiper-button-disabled');
          prevBtn.classList.remove('swiper-button-disabled');
          
          // Custom logic to hide buttons when appropriate
          if (swiper.isEnd) {
            // nextBtn.style.opacity = '0.5'; {% endcomment %}
            // nextBtn.style.pointerEvents = 'none'; {% endcomment %}
          } else {
            // nextBtn.style.opacity = '1'; {% endcomment %}
            nextBtn.style.pointerEvents = 'auto';
          }
          
          if (swiper.isBeginning) {
            //prevBtn.style.opacity = '0.5'; {% endcomment %}
            // prevBtn.style.pointerEvents = 'none'; {% endcomment %}
          } else {
            // prevBtn.style.opacity = '1'; {% endcomment %}
            prevBtn.style.pointerEvents = 'auto';
          }
        }
      });